module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PlanDetailView.js"));
	}, "PlanDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PlanDetailView!./src/pages/Learn/My/PlanDetail/PlanDetailView.js
// module id = 1251
// module chunks = 431